// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"51":"2b2f8977","62":"d7ff4b95","181":"2b2f8977","206":"4cde393f","331":"05773f33","368":"2b2f8977","399":"515f3f93","427":"2b2f8977","887":"515f3f93"}[chunkId] + ".chunk.css";
};